import styled from 'styled-components';

import { color } from '../../../atoms/colors';
import { font } from '../../../atoms/typography';
import { spacing } from '../../../atoms/spacing';

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  gap: ${spacing[8]};
  padding: ${spacing[12]};
  border-radius: ${spacing[8]};
  overflow: hidden;

  &:hover {
    background-color: ${color.darkBlue[50]};
  }

  svg use {
    fill: ${color.darkBlue[1000]};
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[6]};

  em {
    background-color: ${color.blue[50]};
    color: ${color.blue[800]};
  }

  .description {
    ${font('text', 'xs', '400')}
    color: ${color.darkBlue[600]};

    a {
      color: ${color.blue[700]};
    }
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${spacing[12]};

  .title {
    ${font('text', 'sm', '500')}
    color: ${color.darkBlue[800]};
  }

  .type {
    ${font('text', 'xs', '500')}
    color: ${color.darkBlue[600]};
    white-space: nowrap;
    border: 1px solid ${color.darkBlue[100]};
    padding: ${spacing[2]} ${spacing[4]};
    border-radius: ${spacing[6]};
  }
`;
